var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFYoutubeColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5229 0 10 0C4.47716 0 0 4.47715 0 10C0 15.5228 4.47716 20 10 20C15.5229 20 20 15.5228 20 10Z",
    fill: "#FF0209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.245 14.4314C13.9471 14.4637 13.6421 14.4694 13.3498 14.4687C11.0696 14.4665 8.78934 14.4644 6.50981 14.463C5.79236 14.463 5.01097 14.4398 4.45654 13.9838C3.83185 13.4687 3.70186 12.5756 3.65126 11.7675C3.58099 10.6601 3.57537 9.54911 3.63299 8.44097C3.66461 7.83244 3.72012 7.20915 3.98223 6.65824C4.17055 6.26263 4.48465 5.90706 4.88659 5.72015C5.35388 5.50302 5.84296 5.54167 6.34608 5.54096C7.5505 5.53956 8.75491 5.53885 9.95933 5.53745C11.2115 5.53604 12.4644 5.53534 13.7166 5.53394C14.3083 5.53394 14.9435 5.54588 15.4263 5.88809C16.0496 6.32938 16.2189 7.1691 16.2969 7.92871C16.441 9.32777 16.4431 10.7416 16.3025 12.1406C16.2442 12.7175 16.1472 13.3275 15.7671 13.7653C15.3904 14.1995 14.8318 14.3668 14.2457 14.4307L14.245 14.4314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 10.0024L8.64087 8.04053V11.9644L12.0391 10.0024Z",
    fill: "#FF0209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFYoutubeColored);
export default __webpack_public_path__ + "static/media/f-youtube-colored.f684d729eab4c7b7776ab8880e5d085b.svg";
export { ForwardRef as ReactComponent };